export const scrollTop = (classId) => {
  const selector = classId ? classId : ".user-dashboard";
  document.querySelector(selector).scrollIntoView();
};
